import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing, breakpoints }: Theme) => createStyles({
  root: {
    marginTop: spacing(8),
    width: spacing(100),
    [breakpoints.up('lg')]: {
      width: spacing(123),
    },
    [breakpoints.up('xl')]: {
      width: spacing(156),
    },
  },
  file: {
    marginBottom: spacing(2),
  },
  box: {
    marginTop: spacing(3),
  },
});

export default styles;
